import React, { useEffect, useState } from 'react';
import {
  Container,
  Stack,
  Typography,
  Grid,
  Pagination,
  Box,
  CircularProgress
} from '@mui/material';
import { fetchUserWorks, fetchWorks, filterWorks, filterUserWorks } from '../../services/Project';
import WorkCard from './WorkCard';
import WorkFilter from './WorkFilter';
const Work = ({ userTabsValue, userId }) => {
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);


  console.log("Works:", works);



  // ---- Fetch works -------

  const AllWorks = async () => {
    try {
      setLoading(true);
      let response;
      if (userId) {
        response = await fetchUserWorks(userId, page);
      } else {
        response = await fetchWorks(page);
      }

      console.log("response", response);
      setPage(response.current_page);
      setLastPage(response.last_page);
      setWorks(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Works:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    AllWorks();
  }, [page, userId]);



  const handleFilterApply = async (filters) => {
    // Handle the filter application logic here
    console.log("Filters applied on work:", filters);
    try {
      // setLoading(true);
      //const response = await filterWorks(filters);
      let response;
      if (userId) {
        response = await filterUserWorks(userId, filters);
      } else {
        response = await filterWorks(filters);
      }
      console.log("Filtered response:", response);
      setWorks(response.data);
      setPage(response.current_page);
      setLastPage(response.last_page);
      setLoading(false);
    }
    catch (error) {
      console.error("Error applying filters:", error);
      setLoading(false);

    }
  };

  if (loading) {
    return (
      <Stack alignItems="center" sx={{ mb: 2 }}>
        <CircularProgress size={24} />
        <Typography variant="h6" color="text.secondary">
          Loading ...
        </Typography>
      </Stack>
    );
  }


  return (
    <React.Fragment>
      <Container maxWidth="lg" sx={{ mb: 0, padding: '0px' }} disableGutters>

        {works.length === 0 ? (
          <Stack alignItems="center" sx={{ mt: 4, mb: 4 }}>
            <Typography variant="h6" color="text.secondary" align="center">
              No Jobs
            </Typography>
          </Stack>
        ) : (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h5" component="h1" sx={{ color: 'text.primary' }}>
                Jobs
              </Typography>
              <WorkFilter onFilterApply={handleFilterApply} />
            </Stack>
            <Grid container spacing={2}>
              {works.map(work => (
                <Grid size={userTabsValue ? { xs: 12, sm: 6, md: 4 } : { xs: 12, sm: 6, md: 4 }}
                  key={work.work_listing_id}>
                  <WorkCard workContent={work}
                  />
                </Grid>
              ))}
            </Grid>


            {/* Pagination */}
            {lastPage > 1 && (
              <Stack spacing={2} sx={{ mt: 2, mb: 2, alignItems: 'center' }}>
                <Pagination
                  count={lastPage}
                  page={page}
                  onChange={(event, value) => {
                    setPage(value);
                    // AllWorks(value);
                  }}
                  color="primary"
                />
              </Stack>
            )}
          </>
        )}

      </Container>
    </React.Fragment>
  )
}

export default Work